import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Gauge } from 'lucide-react';
import DashboardLayout from '../components/DashboardLayout';
import PageHeader from '../components/PageHeader';
import WellnessIQCard from '../components/WellnessIQCard';
import WellnessTrendSparkline from '../components/WellnessTrendSparkline';

// Pillar -> deep-dive route (mirrors the Dashboard mapping).
const PILLAR_ROUTES = {
  movement:  '/performance',
  recovery:  '/recovery',
  mental:    '/mental',
  nutrition: '/nutrition',
};

/**
 * WellnessIQ — the full "scores & trends" hub (Classic view).
 *
 * NOTE: the Phase-0 "Living World" view is built and parked
 * (components/world/LivingWorld.js + DistrictTile.js + lib/worldState.js) but is
 * intentionally NOT mounted here right now — we'll revisit it later. This page
 * behaves exactly as it did before the World experiment.
 */
const WellnessIQ = () => {
  const navigate = useNavigate();
  return (
    <DashboardLayout>
      <div className="p-4 md:p-8 space-y-6">
        <PageHeader
          tag="Wellness Intelligence"
          tagColor="#CCFF00"
          icon={Gauge}
          title="Wellness IQ"
          subtitle="Your full picture across the four pillars."
          testIdPrefix="wellness-iq"
        />

        <p className="text-xs text-primary/80 font-secondary tracking-wide" data-testid="wellness-iq-hint">
          Tap a pillar to explore →
        </p>

        {/* Composite score + 4 tappable pillar rings */}
        <WellnessIQCard onPillarClick={(key) => {
          const route = PILLAR_ROUTES[key];
          if (route) navigate(route);
        }} />

        {/* 7-day Wellness IQ trend graph */}
        <WellnessTrendSparkline />
      </div>
    </DashboardLayout>
  );
};

export default WellnessIQ;
